import React from 'react';
import { OrderContact } from '../../../../api/shop/types/orderTypes';
import './ContactInformation.css';

interface ContactInformationProps {
  contact: OrderContact;
}

const ContactInformation: React.FC<ContactInformationProps> = ({ contact }) => {
  return (
    <div className="contact-information-container">
      <h3 className="contact-information-title">Contact Information</h3>
      
      <div className="contact-info-grid">
        <div className="contact-info-row">
          <div className="contact-info-item">
            <span className="contact-items-label">Customer Name</span>
            <span className="contact-items-value">{contact.name}</span>
          </div>
          <div className="contact-info-item">
            <span className="contact-items-label">Contact Number</span>
            <span className="contact-items-value">{contact.phone}</span>
          </div>
        </div>
        
        <div className="contact-info-row">
          <div className="contact-info-item full-width">
            <span className="contact-items-label">Email Address</span>
            <span className="contact-items-value">{contact.email}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactInformation;